/**
 * Адреса документов aisearch.tech для подвала (05.10.2026). Отдельно от
 * `ais-legal-zarubezh.ts`: подвал — клиентский компонент, и импорт реестра
 * увозил бы в браузер тела документов на трёх языках. Подписи берутся из
 * переводов интерфейса (`ais_layout.legal_<slug>`). Совпадение со списком
 * реестра проверяет тест.
 */
export const SLAGI_ZARUBEZH = [
  'terms-of-use',
  'privacy-policy',
  'license-terms',
  'license-privacy',
  'marketing-consent',
] as const;
